export enum HolidayKind {
  PUBLIC = "PUBLIC",
  COMPANY = "COMPANY",
  OPTIONAL = "OPTIONAL",
}

export const HolidayKindLabel: Record<HolidayKind, string> = {
  [HolidayKind.PUBLIC]: "Public",
  [HolidayKind.COMPANY]: "Company",
  [HolidayKind.OPTIONAL]: "Optional",
};
